/**
 * TanStack Query key factories.
 * Using a factory pattern avoids string-typo bugs and makes
 * targeted invalidations ergonomic.
 */
export const queryKeys = {
  all: ['condo'] as const,

  dashboard: (condoId: string) => ['condo', 'dashboard', condoId] as const,
  dashboardFinanciero: (condoId: string) =>
    ['condo', 'dashboard', condoId, 'financiero'] as const,

  condominios: () => ['condo', 'condominios'] as const,
  condominio: (id: string) => ['condo', 'condominios', id] as const,

  unidades: (condoId: string, filters?: Record<string, unknown>) =>
    filters && Object.keys(filters).length
      ? (['condo', 'unidades', condoId, filters] as const)
      : (['condo', 'unidades', condoId] as const),
  unidad: (condoId: string, id: string) =>
    ['condo', 'unidades', condoId, id] as const,
  unidadHistorial: (condoId: string, id: string) =>
    ['condo', 'unidades', condoId, id, 'historial'] as const,

  vinculos: (condoId: string, viviendaId?: string) =>
    viviendaId
      ? ['condo', 'vinculos', condoId, viviendaId] as const
      : ['condo', 'vinculos', condoId] as const,

  residentes: (condoId: string) => ['condo', 'residentes', condoId] as const,
  residente: (condoId: string, id: string) =>
    ['condo', 'residentes', condoId, id] as const,

  fondoResumen: (condoId: string) => ['condo', 'fondo-reserva', condoId] as const,
  fondoMovimientos: (condoId: string) =>
    ['condo', 'fondo-reserva', condoId, 'movimientos'] as const,

  gastosComunes: (condoId: string) => ['condo', 'gastos', condoId] as const,
  gastoComun: (condoId: string, id: string) =>
    ['condo', 'gastos', condoId, id] as const,
  gastoComunCargos: (condoId: string, id: string) =>
    ['condo', 'gastos', condoId, id, 'cargos'] as const,

  misCargos: () => ['condo', 'mis-cargos'] as const,

  asambleas: (condoId: string) => ['condo', 'asambleas', condoId] as const,
  asamblea: (condoId: string, id: string) =>
    ['condo', 'asambleas', condoId, id] as const,
  asambleaMisVotos: (condoId: string, id: string) =>
    ['condo', 'asambleas', condoId, id, 'mis-votos'] as const,
  asambleaResultados: (condoId: string, id: string) =>
    ['condo', 'asambleas', condoId, id, 'resultados'] as const,
  asambleaActa: (condoId: string, id: string) =>
    ['condo', 'asambleas', condoId, id, 'acta'] as const,
  actasHistorial: (condoId: string) => ['condo', 'actas-historial', condoId] as const,

  auditLog: (condoId: string) => ['condo', 'audit-log', condoId] as const,

  // Mercado Vecinal
  mercadoListings: (category?: string) =>
    category ? ['mercado', 'listings', category] as const : ['mercado', 'listings'] as const,
  mercadoListing: (id: string) => ['mercado', 'listings', id] as const,
  mercadoMyListings: () => ['mercado', 'my-listings'] as const,
  mercadoSeller: (sellerId: string) => ['mercado', 'sellers', sellerId] as const,
  mercadoSellerRatings: (sellerId: string) =>
    ['mercado', 'sellers', sellerId, 'ratings'] as const,
  mercadoThreads: () => ['mercado', 'threads'] as const,
  mercadoMessages: (threadId: string) =>
    ['mercado', 'threads', threadId, 'messages'] as const,

  // Visitas (pases de visitante)
  visitas: (condoId: string) => ['condo', 'visitas', condoId] as const,
  misVisitas: () => ['condo', 'visitas', 'me'] as const,
  visitaVerificar: (token: string) => ['condo', 'visitas', 'verify', token] as const,

  // Feature flags (Superadmin)
  featureFlags: (tenantId: string) => ['condo', 'feature-flags', tenantId] as const,

  // Me / workspace
  myTenants: () => ['me', 'tenants'] as const,
  admins: (tenantId: string) => ['admins', tenantId] as const,
};
